/** User-facing strings: notifications. */
export const notifications = {
    title: "Notifications",
    descriptionUnread: "{count} unread in this organisation.",
    descriptionNoneUnread: "No unread notifications in this organisation.",
    descriptionLoading: "Agent outages, certificate resets and failed connection tests in this organisation.",
    markAllRead: "Mark all as read",
    markAsRead: "Mark as read",
    markAsReadFor: "Mark as read: {title}",
    openAgents: "Open agents",
    openAgentsFor: "Open agents: {title}",
    openOrganisation: "Open organisation",
    openOrganisationFor: "Open organisation: {title}",
    unread: "Unread",
    unreadPrefix: "Unread: ",
    kindPrefix: "{label}, ",
    recent: "Recent",
    preferencesTitle: "Preferences",
    loading: "Loading notifications...",
    unavailable: "Notifications are unavailable right now.",
    tryAgain: "Try again",
    none: "No notifications",
    noneText:
        "You are notified here when an agent of this organisation stays offline for more than {minutes, plural, one {# minute} other {# minutes}} and when it comes back, when an agent's certificate is reset, and when a connection test of a relayed server fails.",
    hidden: "Hidden by your preferences: {kinds}.",
    viewAll: "View all notifications",
    unexpectedResponse: "Unexpected response",
    bell: {
        label: "Notifications",
        labelUnread: "Notifications, {count} unread",
        badgeMax: "{count}+",
    },
    announcement: "{count, plural, one {# new notification} other {# new notifications}}",
    kinds: {
        agentOffline: {
            label: "Agent offline",
            description: "An agent disconnected and stayed offline for a few minutes.",
        },
        agentOnline: {
            label: "Agent back online",
            description: "An agent that was reported offline connected again.",
        },
        certificateReset: {
            label: "Certificate reset",
            description: "An agent's certificate was reset: it is refused until it is enrolled again.",
        },
        probeFailed: {
            label: "Connection test failed",
            description: "A connection test of a relayed server failed after it had passed or never run.",
        },
        organisationChanged: {
            label: "Changes by Sterfive",
            description: "A Sterfive operator changed an organisation you own or its members. Owners only.",
        },
    },
    duration: {
        lessThanMinute: "less than a minute",
        days: "{count} d",
        hours: "{count} h",
        minutes: "{count} min",
    },
    describe: {
        agentOffline: {
            titleNamed: "Agent {name} went offline",
            titleDeleted: "A deleted agent went offline",
            detail: "It disconnected from the relay and stayed offline for more than {minutes, plural, one {# minute} other {# minutes}}.",
        },
        agentOnline: {
            titleNamed: "Agent {name} is back online",
            titleDeleted: "A deleted agent is back online",
            detailAfter: "It reconnected after {duration} offline.",
            detail: "It reconnected to the relay.",
        },
        certificateReset: {
            titleNamed: "Certificate of {name} was reset",
            titleDeleted: "A deleted agent's certificate was reset",
            detail: "The relay refuses this agent until it is enrolled again (opcua-relay-agent config <token> -f).",
        },
        probeFailed: {
            titleNamed: "Connection test failed for server {name}",
            titleDeleted: "Connection test failed for a deleted server",
            detailMismatch: "The server answered but does not advertise the public relay URL.",
            detailNotVerified: "The test could not reach the server through the relay.",
        },
        organisationChanged: {
            fallback: "Sterfive changed this organisation",
            someone: "a member",
            reason: "Reason given: {reason}",
            create: "Sterfive created the organisation {name}",
            rename: "Sterfive renamed the organisation to {name}",
            delete: "Sterfive deleted the organisation {name}. You no longer belong to it.",
            previousName: "It was called {name}.",
            add: "Sterfive added {who} as {role}",
            role: "Sterfive changed the role of {who} to {role}",
            previousRole: "It was {role}.",
            remove: "Sterfive removed {who} from the organisation",
        },
    },
    preferences: {
        intro: "Choose what appears in the notification list and the header bell. Notifications are shown in the dashboard only: nothing is sent by email.",
        loading: "Loading preferences...",
        unavailable: "Notification preferences are unavailable right now.",
        toastOn: "{label} notifications on",
        toastOff: "{label} notifications off",
        saveFailed: "Failed to save the notification preferences.\n{message}",
    },
};
